import { _projectAppNames, _useMeDb, envTypes } from '../../../project/appConfiguration';
import { fs_db } from '../../firestoreData/appData/fsAppData';
import { _showAppLogs } from '../contexts/LogContext';
import { grts } from './reducerHelpers/dispatchProps';

const rts = {
  handleInit_database: 'handleInit_database',
  handleChange_database: 'handleChange_database',
  handleChange_databaseApp: 'handleChange_databaseApp',
  ...grts
}

export const databaseReducer = (state, action) => {

  let { type, app_state, projectAppName } = action ?? {}
  let { mainApp } = app_state ?? {}

  _showAppLogs.reducerTypes && console.log('✔️ databaseReducer', type)

  switch (type) {

    case rts.handleInit_database:

      const appName = _useMeDb ? _projectAppNames.meetingevolution : _projectAppNames.pojo
      const _appName = appName

      let _environment;

      switch (_appName) {
        case _projectAppNames.meetingevolution:
          switch (document.location.host) {
            case 'mobile.events.meetingevolution.net':
              _environment = 'prod'
              break;
            default:
              _environment = 'dev'
          }
          break;

        case _projectAppNames.thumbstat:
        case _projectAppNames.cardnudge:
        case _projectAppNames.pojo:
          _environment = 'dev'
          break;
        default:
      }

      const _fsdb = fs_db(mainApp).get_fsAlt(mainApp)

      return {
        ...state,
        fsdb: _fsdb,
        fsdbName: _appName
      }

    case rts.handleChange_databaseApp:
      return { ...state, useProdDb: action.prodOverrideOn }

    case rts.handleChange_database:
      return { ...state, fsdb: action.newDb, fsdbName: action.projectAppName }

    default:
      return { ...state }
  }
}

export const databaseHandlers = (dispatch) => {
  return {
    handleChange_database: (newDb, projectAppName) => { dispatch({ type: rts.handleChange_database, dispatch, newDb, projectAppName }) },
    handleChange_databaseApp: (prodOverrideOn) => { dispatch({ type: rts.handleChange_databaseApp, dispatch, prodOverrideOn }) },
    handleInit_database: (app_state) => { dispatch({ type: rts.handleInit_database, dispatch, app_state }) },
  }
}

export const databaseInitialState = (initState) => {
  return { ...initState, refPaths: [] }
};

const isDev_me = () => {
  if (document.location.host.indexOf('mobiledev') >= 0 ||
    document.location.host.indexOf('me-mobile-4410b') >= 0) {
    return true
  } else {
    return false
  }
}

export const isMeProd = () => {
  // return true
  switch (process.env.NODE_ENV) {
    case envTypes.production:
      if (isDev_me()) {
        return false
      } else if (document.location.host.indexOf('mobile') >= 0) {
        return true
      } else {
        return false
      }
    default:
      return false
  }
}
